import * as React from 'react';
import Scenario from '../../models/Scenario';
import StatisticsCalculator from '../../services/statistics/StatisticsCalculator';

class WorkEstimateOverview extends React.Component<{
  scenarios: Scenario[]
}, {
  minTimeEstimate: string,
  maxTimeEstimate: string,
  workEstimateSanity: boolean,
  safetyMargin: number
}> {

  public constructor(props) {
    super(props);

    const defaultSafetyMargin = 2.0;

    const timeEstimates = StatisticsCalculator.calculateLikelyWorkEstimate(props.scenarios, defaultSafetyMargin);
    const minDays = new Intl.NumberFormat('de-DE', { 'style': 'decimal', 'minimumFractionDigits': 2 }).format(this.convertHoursToWorkDays(timeEstimates.min));
    const maxDays = new Intl.NumberFormat('de-DE', { 'style': 'decimal', 'minimumFractionDigits': 2 }).format(this.convertHoursToWorkDays(timeEstimates.max));

    this.state = {
      minTimeEstimate: timeEstimates.min + ' h (' +  minDays + ' days)',
      maxTimeEstimate: timeEstimates.max + ' h (' +  maxDays + ' days)',
      workEstimateSanity: StatisticsCalculator.isWorkEstimateSane(props.scenarios),
      safetyMargin: defaultSafetyMargin
    };
  }

  public render() {
    return (
      <React.Fragment>
        <div id="workestimate-overview">
          <p>Work amount needed for this project is estimated to be {this.state.minTimeEstimate} - {this.state.maxTimeEstimate}.</p>
          <p>Estimate is calculated with safety margin of <strong>{this.state.safetyMargin}x</strong>.</p>
        </div>
      </React.Fragment>
    )
  }

  private convertHoursToWorkDays(hours: number) {
    return hours / 8;
  }
}

export default WorkEstimateOverview;


// WEBPACK FOOTER //
// ./src/components/workestimateoverview/WorkEstimateOverview.tsx